import { PAYMENT_STATUS } from 'domains/customer-order/constants'
import { CATEGORY } from 'domains/payment-method/constants'

const PaymentService = {
  /**
   * Checks if we can create a BankTransfer based on
   *
   * @param {Object} payment - Customer Order Payment object
   */
  isBankTransferCreatable: (payment) => (
    payment.payment_method.category === CATEGORY.BANK_TRANSFER &&
      payment.status === PAYMENT_STATUS.PENDING
  ),
  /**
   * Checks if a Payment.payment_method.category === `bank_transfer`
   *   and if Payment.status === p`ending_settlement`
   *
   * @param {Object} payment - Customer Order Payment object
   */
  isBankTransferPendingSettlement: (payment) => (
    payment.payment_method.category === CATEGORY.BANK_TRANSFER &&
      payment.status === PAYMENT_STATUS.PENDING_SETTLEMENT
  )
}

export default PaymentService